$(function(){

  $('select.filterselectinner').on('change', function() {
    var getheadingname = $(this).attr("data-heading");
    if(getheadingname == "Sort"){
      var getselectedvalue = $(this).val();
      if(getselectedvalue=="Price : low to high"){
        var alphabeticallyOrderedDivs = $('#b-stepp-4 .create-box > li').sort(function (a, b) {

          var contentA =parseInt( $(a).attr('data-sort'));
          var contentB =parseInt( $(b).attr('data-sort'));
          return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
        });
        $("#b-stepp-4 .collection_Prod_container ul.create-box").html(alphabeticallyOrderedDivs);
      }
      else if(getselectedvalue=="Price : high to low"){
        var alphabeticallyOrderedDivs = $('#b-stepp-4 .create-box > li').sort(function (a, b) {

          var contentA =parseInt( $(a).attr('data-sort'));
          var contentB =parseInt( $(b).attr('data-sort'));
          return (contentA > contentB) ? -1 : (contentA < contentB) ? 0 : 1;
        });
        $("#b-stepp-4 .collection_Prod_container ul.create-box").html(alphabeticallyOrderedDivs);
      }
      else if(getselectedvalue=="Weight : high to low"){
        var alphabeticallyOrderedDivs = $('#b-stepp-4 .create-box > li').sort(function (a, b) {

          var contentA =parseInt( $(a).attr('data-weight'));
          var contentB =parseInt( $(b).attr('data-weight'));
          return (contentA > contentB) ? -1 : (contentA < contentB) ? 0 : 1;
        });
        $("#b-stepp-4 .collection_Prod_container ul.create-box").html(alphabeticallyOrderedDivs);
      }
      else if(getselectedvalue=="Weight : low to high"){
        var alphabeticallyOrderedDivs = $('#b-stepp-4 .create-box > li').sort(function (a, b) {

          var contentA =parseInt( $(a).attr('data-weight'));
          var contentB =parseInt( $(b).attr('data-weight'));
          return (contentA < contentB) ? -1 : (contentA > contentB) ? 1 : 0;
        });
        $("#b-stepp-4 .collection_Prod_container ul.create-box").html(alphabeticallyOrderedDivs);
      }
      else{
      }
    } else {
      var checkiffoundanyproduct = "notfound";
      var filter1value = $('select#filterselect1.filterselectinner').val();
      var filter2value = $('select#filterselect2.filterselectinner').val();
      // console.log(filter1value, filter2value);
      //  var filter3value = $('select#filterselect3.filterselectinner').val();
      $("#b-stepp-4 .collection_Prod_container .create-box > li").each(function () {
        var getalttags = $(this).attr("data-alltags");
        // console.log(getalttags, getalttags.indexOf(filter1value), getalttags.indexOf(filter2value));
        //if((getalttags.indexOf(filter1value) != -1) && (getalttags.indexOf(filter2value) != -1) && (getalttags.indexOf(filter3value) != -1)){
        if ((getalttags.indexOf(filter1value) != -1) && (getalttags.indexOf(filter2value) != -1)) {
          $(this).addClass("showproduct");
          $(this).removeClass("hideproduct");
          checkiffoundanyproduct = "found";
        } else {
          $(this).addClass("hideproduct");
          $(this).removeClass("showproduct");
        }
      });
      if (checkiffoundanyproduct == "notfound") {
        $("#noproffound").show();
      } else {
        $("#noproffound").hide();
      }
    }
  });

  $(".paginatenumbers a").click(function(e){
    e.preventDefault();
    var getnexturl = $(this).attr("href");
    $.ajax({
      url: getnexturl,
      cache: false,
      success: function(response) {
        var result = $(response).find("#getajaxpro").html();
        $("#getajaxpro").html(result);
      }
    });
  });

//    Slider Js

//     $("#owl-demo").owlCarousel({
//       dots: false,
//       nav: false,
//       items : 4,
//       loop: false,
//       itemsDesktop : [1199,3],
//       itemsDesktopSmall : [979,3]
//     });
});

$(function(){
//   $(".main_nav ul.menu a.top_link[data-dropdown-rel='search']").unbind('click').bind("click", function(e){
//     e.preventDefault();
//     console.log("click");
//     $("div.search_bar").slideToggle("linear");
//   });

  if (window.location.href.indexOf('apps/cart_data/') > 0) {
    $("body").addClass("app_cart_data");
  }

  if(window.location.href.indexOf('apps/cart_data/cart/confirm') > 0){
    $("body").addClass("app_cart_confirm");
  }

  $("img.email_img").click(function(){
    $("footer #contact_form .action_button.sign_up").trigger("click");
  })

  $(".main_nav ul.menu a.top_link[data-dropdown-rel='search']").on("mouseenter", function() {
    $(".dropdown_container[data-dropdown='search']").show();
  }).on("mouseleave", function() {
    $(".dropdown_container[data-dropdown='search']").hide();
  });

    $(".dropdown_container[data-dropdown='search']").on("mouseenter", function() {
    $(this).show();
  }).on("mouseleave", function() {
    $(this).hide();
  });

});

// $( document ).ajaxComplete(function() {
//   if (window.location.href.indexOf('apps/cart_data/') > 0) {
//     $("body").addClass("app_cart_data");
//   }
//   if(window.location.href.indexOf('apps/cart_data/cart/confirm') > 0){
//     $("body").addClass("app_cart_confirm");
//   }
// });
